<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light navbar-stick-dark" data-navbar="sticky">
      <header-component></header-component>
    </nav>
    <header
      class="header text-white h-fullscreen pb-0 overflow-hidden"
      style="background-image: url(../assets/img/vector/16.png); background-color: #262a37;"
    >
      <div
        class="overlay opacity-95"
        style="background-image: linear-gradient(to bottom, #09203f 0%, #537895 100%);"
      ></div>
      <div class="container text-center">
        <div class="row align-items-center h-100">
          <div class="col-md-8 mx-auto">
            <h1>Inventory Management Application</h1>
            <p class="lead mt-4 mb-7">
              Simple, User Friendly, Customizable Inventory Management Solution for shops
            </p>
          </div>

          <div class="col-md-8 mx-auto align-self-end">
            <img
              class="mt-7"
              src="../../../assets/img/preview/inventory_page.png"
              alt="img"
              data-aos="fade-up"
            />
          </div>
        </div>
      </div>
    </header>
    <main class="main-content">
      <section class="section bg-gray overflow-hidden">
        <div class="container-fluid">
          <div class="row gap-y align-items-center">
            <div class="col-md-4 mx-auto text-center">
              <img
                class="border shadow-7"
                src="../../../assets/img/preview/inventory_2.png"
                alt="..."
                data-aos="fade-right"
              />
            </div>

            <div class="col-md-4 mx-auto">
              <h3>Point Of Sale</h3>
              <p>
                Very simple to create sale during rush at your shop and easy to generate invoice as
                well. We have advance search to search products where you can use barcode as well.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section overflow-hidden">
        <div class="container-fluid">
          <div class="row gap-y align-items-center">
            <div class="col-md-4 mx-auto text-center">
              <img
                class="border shadow-7"
                src="../../../assets/img/preview/shot-2.png"
                alt="..."
                data-aos="fade-left"
              />
            </div>

            <div class="col-md-4 mx-auto order-md-first">
              <h3>Customizable Reports</h3>
              <p>
                Inventory App comes with diverse set of readily available business reports with
                powerful and actionable insigts. Different graphs can help you to track changes in
                your inventory over a period of time.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section class="section bg-gray overflow-hidden">
        <div class="container-fluid">
          <div class="row gap-y align-items-center">
            <div class="col-md-4 mx-auto text-center">
              <img
                class="border shadow-7"
                src="../../../assets/img/preview/shot-4.png"
                alt="..."
                data-aos="fade-right"
              />
            </div>

            <div class="col-md-4 mx-auto">
              <h3>Multiple Price Tiers</h3>
              <p>
                This unique feature allows you to add multiple price varients based on various
                constraints like quantity, customer type viz. wholesale and retail, special
                discounts on festivals.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section class="section">
        <div class="container">
          <header class="section-header">
            <h2>Features</h2>
            <hr />
            <p class="lead">
              Apart from the standard inventory features e.g. these are some unique features
            </p>
            <br />
          </header>

          <div class="row gap-y text-center">
            <div class="col-md-6 col-xl-4 feature-1">
              <p class="feature-icon lead-8 text-danger">
                <i class="icon-lock"></i>
              </p>
              <h5>Dynamic Access Control</h5>
              <p class="text-muted">
                You can assign specific permissions to the users based on their roles so that they
                can only access specific modules in the applicaiton.
              </p>
            </div>

            <div class="col-md-6 col-xl-4 feature-1">
              <p class="feature-icon lead-8 text-info">
                <i class="icon-cloud"></i>
              </p>
              <h5>Cloud</h5>
              <p class="text-muted">
                Cloud infrastructure allow you to use our app on almost any device also data
                security is an advantage as all your business data stays in our protected
                environment.
              </p>
            </div>

            <div class="col-md-6 col-xl-4 feature-1">
              <p class="feature-icon lead-8 text-success">
                <i class="icon-document"></i>
              </p>
              <h5>Barcode Generator</h5>
              <p class="text-muted">
                You can generate an unique barcode against your product and print it in bulk
                quantity.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!--
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      | FAQ
      |‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒‒
      !-->
      <!-- <section id="section-faq" class="section">
        <div class="container">
          <header class="section-header">
            <small>FAQ</small>
            <h2>Frequently Asked Questions</h2>
            <hr />
            <p>Got a question? We've got answers. If you have some other questions, contact us using email.</p>
          </header>

          <div class="row gap-y">
            <div class="col-md-6 col-xl-4">
              <h5>Is this a secure site for purchases?</h5>
              <p>Absolutely! We work with top payment companies which guarantees your safety and security. All billing information is stored on our payment processing partner which has the most stringent level of certification available in the payments industry.</p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Can I cancel my subscription?</h5>
              <p>You can cancel your subscription anytime in your account. Once the subscription is cancelled, you will not be charged next month. You will continue to have access to your account until your current subscription expires.</p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>How long are your contracts?</h5>
              <p>Currently, we only offer monthly subscription. You can upgrade or cancel your monthly account at any time with no further obligation.</p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Can I update my card details?</h5>
              <p>Yes. Go to the billing section of your dashboard and update your payment information.</p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Can I request refund?</h5>
              <p>Unfortunately, not. We do not issue full or partial refunds for any reason.</p>
            </div>

            <div class="col-md-6 col-xl-4">
              <h5>Can I try your service for free?</h5>
              <p>Of course! We’re happy to offer a free plan to anyone who wants to try our service.</p>
            </div>
          </div>
        </div>
      </section> -->
    </main>
  </div>
</template>
<script>
import header from "../../../components/Header";

export default {
  data: () => ({}),
  components: {
    "header-component": header
  }
};
</script>
